// @flow
import $ from 'jquery';
import JQueryView from '../../../common/JQueryView';

export default class ShowView extends JQueryView {
  constructor() {
    super('.investors');

    const row = 6;
    const lineHeight = 28;
    const fieldHeight = row * lineHeight;

    if (
      $('#thought-content').height() <= fieldHeight ||
      $('#thought-content').height() == null
    ) {
      $('#thought-readmore').removeClass('readmore');
      $('#check1').hide();
    }

    if ($('#introduction-content').height() <= fieldHeight) {
      $('#introduction-readmore').removeClass('readmore');
      $('#check2').hide();
    }

    if (
      $('#destination-content').height() <= fieldHeight ||
      $('#destination-content').height() == null
    ) {
      $('#destination-readmore').removeClass('readmore');
      $('#check3').hide();
    }
  }
}
